module.exports = [{
      plugin: require('../node_modules/gatsby-omni-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"enableListener":true,"preconnect":["https://fonts.googleapis.com","https://fonts.gstatic.com"],"web":[{"name":"Shadows Into Light","file":"https://fonts.googleapis.com/css2?family=Shadows+Into+Light&display=swap"},{"name":"Rowdies","file":"https://fonts.googleapis.com/css2?family=Rowdies:wght@300&display=swap"},{"name":"Permanent Marker","file":"https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap"}]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"8c1da16eb7537d0172e52872c6c2e779"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
